import { render, staticRenderFns } from "./PointBack.vue?vue&type=template&id=bf2f1166&scoped=true"
import script from "./PointBack.vue?vue&type=script&lang=js"
export * from "./PointBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2f1166",
  null
  
)

export default component.exports